import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { SendEmailRequest } from "../../models/request/send-email/SendEmailRequest";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SendEmailResponse } from "../../models/response/send-email/send-email-response";

@Injectable({
    providedIn: 'root'
})
export class SendEmailService {

    private sendEmailUrl = `${environment.serverUrl}/sendemail`;

    constructor(private http: HttpClient) {
    }

    sendEmail(sendEmail: SendEmailRequest): Observable<SendEmailResponse> {
        const httpOptions = {
            headers: new HttpHeaders(
                { 'Content-Type': 'application/json' }
            )
        }
        return this.http.post<SendEmailResponse>(this.sendEmailUrl, sendEmail, httpOptions);
    }
}
